import axios from 'axios';
import { API } from './api';

// Instancia de axios con la URL base ya configurada.
// timeout: evita que un guardado se quede "pegado" para siempre sin avisar
// si el servidor tarda demasiado en responder — mejor mostrar un error claro
// que dejar al usuario esperando frente a un botón que nunca reacciona.
const axiosAuth = axios.create({ baseURL: API, timeout: 20000 });

// Interceptor: adjunta automáticamente el token JWT a cada petición
axiosAuth.interceptors.request.use((config) => {
  const token = localStorage.getItem('playfesor_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor: si el token expira, redirige al login
axiosAuth.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('playfesor_token');
      localStorage.removeItem('playfesor_usuario');
      window.location.href = '/login';
    }
    // Sin esto, un timeout o una caída de red llegan a las pantallas con
    // error.response = undefined, y como cada pantalla arma su mensaje con
    // `err.response?.data?.error || '...'`, quedaría en blanco o en un
    // mensaje genérico. Se normaliza aquí una vez para que todas hereden un
    // aviso claro sin tener que tocar cada pantalla.
    if (!error.response) {
      const mensaje = error.code === 'ECONNABORTED'
        ? 'La conexión tardó demasiado en responder. Intenta de nuevo.'
        : 'No se pudo conectar con el servidor. Revisa tu conexión e intenta de nuevo.';
      error.response = { data: { error: mensaje } };
    }
    return Promise.reject(error);
  }
);

export default axiosAuth;
